import React, { Fragment, useState } from 'react'

import { useMediaQuery } from 'react-responsive'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { useUserSubscriptions } from '../../hooks'
import { API__USER } from 'api'
import { USER__SET_SUBSCRIPTION, USER__SET_SUBSCRIPTIONS } from 'store/actions'
import { PRODUCT_LIST } from 'common/constants/ProductConstants'
import { DowngradeTo } from './DowngradeTo'
import { SubscriptionItem } from './SubscriptionItem'
import { isExpired } from '../../utils'
import Toast from 'components/Toast/Toast'

export const SubscriptionBanner = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 1199px)' })
    const { user_details: userDetails, user_subscription: userSubscription } = useSelector(state => state)
    const { t } = useTranslation()
    const subscriptions = useUserSubscriptions()
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)

    const currentProductCode = userSubscription.product.productCode
    const isDeprecatedFreePlan = currentProductCode === PRODUCT_LIST.Free
    const isTrial = currentProductCode === PRODUCT_LIST.Trial
    if ((userSubscription.expired && isTrial) || isDeprecatedFreePlan) {
        return (
            <div className="subscriptions__state subscriptions__state-free">
                <h2>
                    {t(
                        'Sorry, the trial period is over. Take a look at the packages to find out how you can keep creating engaging content!',
                    )}
                </h2>
            </div>
        )
    }

    // TODO need refactoring tech debt
    const preparedSubscriptions = subscriptions
        ? subscriptions.filter(
              sub => (!isExpired(sub.expirationDate) && sub.product.productCode !== PRODUCT_LIST.Free) || sub.selected,
          )
        : []
    const hasSeveralActiveSubs = preparedSubscriptions.length > 1
    const hideTrialIfHasPaidSub = preparedSubscriptions.filter(
        sub =>
            (hasSeveralActiveSubs && sub.product.productCode !== PRODUCT_LIST.Trial) ||
            (!hasSeveralActiveSubs && sub.product.productCode === PRODUCT_LIST.Trial) ||
            sub.selected,
    )

    const updateRecurringOption = async recurringValue => {
        try {
            setIsLoading(true)
            await API__USER.UPDATE_CURRENT_SUBSCRIPTION(userSubscription.id, {
                ...userSubscription,
                recurringEnabled: recurringValue,
            })
            const message = recurringValue ? t('Auto-renewal enabled successfully') : t('Auto-renewal disabled')
            Toast('success', { message })
            dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(userDetails.id)))
            dispatch(USER__SET_SUBSCRIPTIONS(await API__USER.GET_SUBSCRIPTIONS(userDetails.id)))
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <>
            {hideTrialIfHasPaidSub ? (
                <div className="subscriptions__state">
                    {hideTrialIfHasPaidSub
                        .filter(subscription => subscription.productForDowngrade)
                        .map((subscription, i) => {
                            return (
                                <Fragment key={i}>
                                    <DowngradeTo subscription={subscription} />
                                </Fragment>
                            )
                        })}
                    {hideTrialIfHasPaidSub.map(subscription => {
                        return (
                            <SubscriptionItem
                                key={subscription.id}
                                subscription={subscription}
                                onUpdateRecurringOption={updateRecurringOption}
                                isMobile={isMobile}
                                isLoading={isLoading}
                            />
                        )
                    })}
                </div>
            ) : null}
        </>
    )
}
